<template>
	<SuiButton
		v-tooltip="expandCollapseTooltip"
		:is-disabled="isDisabled"
		class="task-list-row-expand-button"
		variant="icon"
		:aria-label="isOpen ? $t('collapse') : $t('expand')"
		@click="$emit('click')"
	>
		<SuiIcon
			:name="
				isOpen
					? 'icon-arrow-down-filled-16'
					: 'icon-arrow-right-filled-16'
			"
		/>
	</SuiButton>
</template>

<script setup lang="ts">
import { SuiButton, SuiIcon } from '@developers/scoro-ui';
import { useTranslation } from '@/composables';

export interface TaskListRowExpandButtonProps {
	isOpen: boolean;
	isDisabled?: boolean;
	expandCollapseTooltip?: string;
}

defineProps<TaskListRowExpandButtonProps>();

defineEmits<{
	(e: 'click'): void;
}>();

const { t } = useTranslation();
</script>

<style lang="scss">
.task-list-row-expand-button {
	--sui-button-h-padding: 0.5rem;
	--sui-button-v-padding: 0.5rem;
	--sui-button-icon-color: #{$neutral-60};
	--sui-button-hover-background-color: transparent;
	--sui-button-background-color: transparent;

	visibility: hidden;
	margin-left: 0.5rem;

	&:hover {
		--sui-button-hover-background-color: #{$neutral-20};
	}
}
</style>
